import { DroplistItem } from '@eforall/dashboard';
import { StaticDataService } from '../../../../services';


export function getDisplayTypeItems(staticData: StaticDataService): DroplistItem<unknown, number>[] {

	const displayTypes = staticData.display_types.all
		.map(d => ({ ...d }))
		.sort((a, b) => {

			//
			// Sort by category.sortOrder (asc)
			//
			if (a.category !== b.category) {
				return a.category.localeCompare(b.category);
			}

			//
			// Sort by item.name (asc)
			//
			return a.name.localeCompare(b.name);
		});


	const items: DroplistItem<unknown, number>[] = displayTypes.map(d => {

		return {
			uniqueId: d.id,
			iconContext: { iconClass: d.icon, iconStyle: 'fa-regular', text: d.name, hideText: 'never' },
			groupName: d.category,
			customSort: d.name,
		}
	});

	return items;
}